<div class="container">
  <div class="header-title-container">
    <p><adp-label labelKey="Account_Change_Password_Heading"></adp-label></p>
  </div>
  <div class="mt-20 mb-20 max-width-82">
    <div class="mt-20 header-desc">
      <adp-label labelKey="Account_Change_Password_Instruction"></adp-label>
    </div>
  </div>
  <div class="password-container max-width-82">
    <form [formGroup]="passwordForm" (ngSubmit)="updatePassword()" class="mt-32" fxLayout="column" fxLayoutAlign="start stretch">
      <pgh-password-form
        [forFormGroup]="passwordForm"
        [showCurrentPasswordField]="showCurrentPassword"
        [passwordLabelSFKey]="'ChangePasswordForm_PasswordField_Label'"
        [confirmPasswordLabelSFKey]="'ChangePasswordForm_ConfirmPasswordField_Label'"></pgh-password-form>

      <div class="mt-32">
        <button
          mat-flat-button
          color="accent"
          type="submit"
          [disabled]="passwordForm.invalid"
          [gtmClick]="getViewLabel('Account_Change_Password_Update_Password')">
          <adp-label labelKey="Account_Change_Password_Update_Password"></adp-label>
        </button>
        <mat-spinner *ngIf="isLoading" class="contract-loading d-inline ml-10 mt-8 position-absolute" [diameter]="30"></mat-spinner>
      </div>
    </form>
  </div>
</div>
